import { render, staticRenderFns } from "./PayCenter.vue?vue&type=template&id=0705daa4&scoped=true&"
import script from "./paycenter.js?vue&type=script&lang=js&"
export * from "./paycenter.js?vue&type=script&lang=js&"
import style0 from "./PayCenter.vue?vue&type=style&index=0&id=0705daa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0705daa4",
  null
  
)

export default component.exports